import React, { FC, ReactElement, useContext } from 'react'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { LanguageContext } from '../../Common/Contexts'
import { BrandingLanguage } from '../../../../i18n'
import Loader from '../../Common/Components/Loader'

export const BrandingSubmission: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler

    return (
        <div className='branding-submission'>
            <div className='bs-loading-info-container'>
                <h3 className='bs-loading-info'>{language.get(BrandingLanguage.Branding_Submission_Line1)}</h3>
                <h3 className='bs-loading-info'>{language.get(BrandingLanguage.Branding_Submission_Line2)}</h3>
            </div>
            <Loader className='bs-loading-spinner' />
        </div>
    )
}
